import apiClient from "@/util/AxiosUtils";

//登录
export function login(params) {
  return apiClient.post("/user_login/login", params);
}
export function wxLogin(params) {
  return apiClient.get("/user_login/wx_login", params);
}

//获取手机验证码
export function getLoginCode(params) {
  return apiClient.post("/user_login/code", params);
}

//手机号登录
export function phoneLogin(params) {
  return apiClient.post("/user_login/code_login", params);
}

//手机号绑定
export function phoneLoginBound(params) {
  return apiClient.post("/user/bound", params);
}

//获取用户信息
export function getUserInfo(params) {
  return apiClient.get("/user/userInfo", params);
}
//文件上传
export function uploadFile(params) {
  return apiClient.uploadFile("/admin/file/upload", params);
}

//文件上传1
export function uploadFile1(params) {
  return apiClient.uploadFile("/admin/file/upload1", params);
}
//获取分类
export function getCategory(params) {
  return apiClient.get("/category/p/table", params);
}

//地址
export function addAddress(params) {
  return apiClient.post("/address/addAddr", params);
}
export function getAddressList(params) {
  return apiClient.get("/address/list", params);
}
export function updateAddress(params) {
  return apiClient.put("/address/updateAddr", params);
}
export function deleteAddress(params) {
  return apiClient.delete("/address/deleteAddr/" + params);
}

//创作者
export function regCreator(params) {
  return apiClient.post("/creatorInfo/save", params);
}
export function getCreator(params) {
  return apiClient.get("/creatorInfo/p/detail", params);
}
export function updateCreator(params) {
  return apiClient.post("/creatorInfo/update", params);
}
export function getCreatorList(params) {
  return apiClient.post("/creatorInfo/p/list", params);
}
export function getCreatorListHome(params) {
  return apiClient.post("/creatorInfo/p/page", params);
}

//作品
export function getArtisArtworkListHome(params) {
  return apiClient.post("/artistArtwork/p/page", params);
}
export function getArtisArtworkList(params) {
  return apiClient.post("/artistArtwork/myPage", params);
}
// 新版 myPage 接口（保留旧函数供其他页面继续使用）
export function getArtisArtworkMyPage(params) {
  return apiClient.post("/artistArtwork/myPage", params);
}
export function addArtisArtwork(params) {
  return apiClient.post("/artistArtwork/add", params);
}
export function updateArtisArtwork(params) {
  return apiClient.post("/artistArtwork/update", params);
}
export function updateArtisArtworkStatus(params) {
  return apiClient.post("/artistArtwork/updateStatus", params);
}
export function artDetail(params) {
  return apiClient.post("/artistArtwork/p/detail", params);
}

export function updateCreatorDesignStatus(params) {
  return apiClient.post("/creatorDesign/updateStatus", params);
}

//艺术标签管理
export function getArtTagsList(params) {
  // return apiClient.post("/artTags/page", params);
  return apiClient.get("/sys/config/list", params);
}

//字体分页
export function getFontsList(params) {
  return apiClient.post("/fonts/p/page", params);
}

//商品
export function getProductList(params) {
  return apiClient.post("/home/p/hotProductPage", params);
}
export function getProductList2(params) {
  return apiClient.post("/product/p/page", params);
}

//个人图库
export function getLocalImageList(params) {
  return apiClient.post("/localImage/page", params);
}
export function addLocalImage(params) {
  return apiClient.post("/localImage/add", params);
}

//关注
export function checkHeart(id) {
  return apiClient.get("/userFollow/check/" + id);
}
export function addHeart(id) {
  return apiClient.post("/userFollow/follow/" + id);
}
export function cancelHeart(id) {
  return apiClient.post("/userFollow/unfollow/" + id);
}
export function getHeartList(params) {
  return apiClient.post("/userFollow/list_creators", params);
}

//支付接口
export function getAliPay(params) {
  return apiClient.post("/alipay/createPayOrder", params);
}

//支付宝支付状态查询
export function getAliPayState(params) {
  return apiClient.get("/alipay/queryTradeResult", params);
}

//订单列表
export function getOrderList(params) {
  return apiClient.post("/mallOrder/list", params);
}

//订单详情
export function getOrderDetail(orderId) {
  return apiClient.get("/mallOrder/info/" + orderId);
}

//取消订单
export function cancelOrderById(params) {
  return apiClient.post("/mallOrder/cancel/" + params.orderId);
}

//批量上架商品
export function batchAddProduct(params) {
  return apiClient.post("/creatorDesign/saveBatch", params);
}
//获取商品列表
export function getDesignProductList(params) {
  return apiClient.post("/creatorDesign/p/page", params);
}

//商品点赞
export function addProductLike(params) {
  return apiClient.post("/creatorDesignFollow/follow/" + params.designId);
}
//取消点赞
export function cancelProductLike(params) {
  return apiClient.post("/creatorDesignFollow/unfollow/" + params.designId);
}

//个人图库删除
export function localImageDel(params) {
  return apiClient.post("/localImage/delete/" + params.localImageId);
}

//交易记录
export function getShopWalletList(params) {
  return apiClient.get("/api/shopwallet/page", params);
}

//我的积分
export function getUserPointList(params) {
  return apiClient.get("/api/userpoint/page", params);
}
//获取所有地图的点
export function getMapPoint(params) {
  return apiClient.post("exhibition/p/all");
}

//分润计算
export function getIncomeVal(id) {
  return apiClient.get("/sys/config/info/" + id);
}

//获取首页抽奖活动列表
export function getLotteryList(params) {
  return apiClient.post("lottery/p/page", params);
}

//获取可抽奖次数
export function getLotteryCount(id) {
  return apiClient.get("/lottery/count/" + id);
}

//获取抽奖详情
export function getLotteryDetail(id) {
  return apiClient.get("/lottery/p/info/" + id);
}

//抽奖
export function lottery(id) {
  return apiClient.get("/lottery/tryLottery/" + id);
}

//获取中奖参与者列表
export function getLotteryUserList(params) {
  return apiClient.post("/lotterylist/p/page", params);
}

//中奖记录
export function getLotteryRecordList(params) {
  return apiClient.post("/lotterylist/page", params);
}

//首页顶部轮播信息
export function getHomeBanner() {
  return apiClient.get("/notice/p/page");
}
